const EMPTY_PERMISSION = Object.freeze({
  canView: false,
  canCreate: false,
  canUpdate: false,
  canDelete: false,
});

export const PERMISSION_ACTIONS = [
  { key: "canView", label: "Read" },
  { key: "canCreate", label: "Create" },
  { key: "canUpdate", label: "Update" },
  { key: "canDelete", label: "Delete" },
];

export const createEmptyScreenPermissions = (screenDefs = []) => {
  const permissions = {};
  screenDefs.forEach((screen) => {
    const code = String(screen?.screenCode || "").toUpperCase();
    if (!code) return;
    permissions[code] = { ...EMPTY_PERMISSION };
  });
  return permissions;
};

export const screenPermissionsFromRole = (screenDefs = [], rolePermissions = []) => {
  const permissions = createEmptyScreenPermissions(screenDefs);
  (Array.isArray(rolePermissions) ? rolePermissions : []).forEach((item) => {
    const code = String(item?.screenCode || "").toUpperCase();
    if (!code || !permissions[code]) return;
    permissions[code] = {
      canView: Boolean(item.canView),
      canCreate: Boolean(item.canCreate),
      canUpdate: Boolean(item.canUpdate),
      canDelete: Boolean(item.canDelete),
    };
  });
  return permissions;
};

export const toggleScreenPermission = (permissions, screenCode, actionKey) => {
  const code = String(screenCode || "").toUpperCase();
  const current = permissions[code] || { ...EMPTY_PERMISSION };
  const nextValue = !current[actionKey];
  const next = { ...current, [actionKey]: nextValue };

  if (actionKey === "canView" && !nextValue) {
    next.canCreate = false;
    next.canUpdate = false;
    next.canDelete = false;
  } else if (actionKey !== "canView" && nextValue) {
    next.canView = true;
  }

  return { ...permissions, [code]: next };
};

export const hasAnyScreenPermission = (permissions) =>
  Object.values(permissions || {}).some(
    (item) => item?.canView || item?.canCreate || item?.canUpdate || item?.canDelete
  );

export const toScreenPermissionPayload = (screenDefs = [], permissions = {}) =>
  screenDefs
    .map((screen) => {
      const screenCode = String(screen?.screenCode || "").toUpperCase();
      const item = permissions[screenCode] || EMPTY_PERMISSION;
      return {
        screenCode,
        screenName: screen?.screenName || screenCode,
        canView: Boolean(item.canView),
        canCreate: Boolean(item.canView && item.canCreate),
        canUpdate: Boolean(item.canView && item.canUpdate),
        canDelete: Boolean(item.canView && item.canDelete),
      };
    })
    .filter((item) => item.canView || item.canCreate || item.canUpdate || item.canDelete);

export const countGrantedScreens = (permissions = {}) =>
  Object.values(permissions).filter(
    (item) => item?.canView || item?.canCreate || item?.canUpdate || item?.canDelete
  ).length;

export const permissionsObjectToPayload = (permissions = {}) =>
  Object.entries(permissions)
    .map(([screenCode, item]) => ({
      screenCode: String(screenCode).toUpperCase(),
      canView: Boolean(item?.canView),
      canCreate: Boolean(item?.canView && item?.canCreate),
      canUpdate: Boolean(item?.canView && item?.canUpdate),
      canDelete: Boolean(item?.canView && item?.canDelete),
    }))
    .filter((item) => item.canView || item.canCreate || item.canUpdate || item.canDelete);
